import React from 'react';
import { isUserLoggedIn, getUserRole } from '../../shared/utils/function';
import { ROLE } from '../../shared/constants/common';
import { fireAndForgetAddCreatorCategories } from '../../shared/actions/contentAction';
import { useNavigation } from '../../shared/utils/useNavigation';
import './button.css';

const getCreatorUsername = (creator) => {
  const rawUsername = creator && typeof creator === 'object' ? creator.username : creator;
  return typeof rawUsername === 'string' ? rawUsername.replace(/^@/, '').trim() : '';
};

const ViewProfileButton = ({ creator, children }) => {
  const navigate = useNavigation();
  const isLoggedIn = isUserLoggedIn();
  const userRole = getUserRole();

  const handleViewProfile = (event) => {
    if (event?.defaultPrevented) {
      return;
    }

    const username = getCreatorUsername(creator);
    if (!username) {
      return;
    }

    if (isLoggedIn && userRole === ROLE.USER && creator && typeof creator === 'object') {
      fireAndForgetAddCreatorCategories(creator);
    }

    navigate.toProfile(username);
  };

  if (!React.isValidElement(children)) {
    return null;
  }

  const childOnClick = children.props.onClick;
  return React.cloneElement(children, {
    onClick: (event) => {
      if (typeof childOnClick === 'function') {
        childOnClick(event);
      }
      handleViewProfile(event);
    }
  });
};

export default ViewProfileButton;

